import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { FeesEstimate } from './fees-estimate.model';

@Injectable({ providedIn: 'root' })
export class FeesEstimationService {

  constructor(private http: HttpServices) {
  }


  add(feesEstimate: FeesEstimate) {
    return this.http.post('FeesEstimation/Add', feesEstimate);
  }
  Update(feesEstimate: FeesEstimate) {
    return this.http.post('FeesEstimation/Update', feesEstimate);
  }

  // UpdateTransitDate(feesEstimate: FeesEstimate) {
  //   return this.http.post('FeesEstimation/EditTransitDate', feesEstimate);
  // }
  get(Id: string) {
    return this.http.get('FeesEstimation/Get/' + Id);
  }
  getAll(CreatedBy: string) {
    return this.http.get('FeesEstimation/GetAll?CreatedBy='+CreatedBy);
  }

  GetByIMOAndUserId(IMONO: string, userId: string, directionId: number) {
    return this.http.post('FeesEstimation/GetByIMOAndUserId', { IMONO, userId, directionId });
  }

  GetByIMO(IMONO: string) {
    return this.http.get('FeesEstimation/GetByIMO?IMONO='+ IMONO);
  }

  CancelFeesRequest(feesRequestId: string,email:string) {
    return this.http.post('FeesEstimation/CancelFeesRequest', { feesRequestId , email });
  }
  GetFeesEstimationValidFor(){
    return this.http.get('Transit/GetFeesEstimationValidFor');
  }

}
